import React from "react";
import wp1 from "../assets/home4.jpg";
import wp2 from "../assets/home7.jpg";
import wp3 from "../assets/home8.jpg";
import wp4 from "../assets/home11.jpg";

const materials = [
  {
    title: "High-Performance Waterproof Membranes",
    desc: "We use advanced waterproof membranes that create a strong, flexible, and seamless barrier against water penetration. These membranes are ideal for terraces, roofs, and basements, ensuring long-term protection even under extreme weather conditions.",
    img: wp1,
  },
  {
    title: "Premium Protective Coatings",
    desc: "Our protective coatings are designed to resist moisture, UV rays, heat, and chemical exposure. These coatings not only prevent leakage but also enhance surface durability and extend the overall lifespan of the structure.",
    img: wp2,
  },
  {
    title: "Crack Sealing & Injection Systems",
    desc: "We use advanced crack sealing and injection systems that penetrate deep into structural gaps. This technology permanently seals cracks, prevents further expansion, and stops water intrusion at its root level.",
    img: wp3,
  },
  {
    title: "Insulation & Drainage Technology",
    desc: "Our modern insulation and drainage systems control moisture flow and prevent water accumulation. This ensures proper ventilation, reduced dampness, and long-term structural safety for basements and foundations.",
    img: wp4,
  },
];

const MaterialsTechnology = () => {
  return (
    <>
      {/* MATERIALS SECTION */}
      <section className="bg-white py-32 px-4 md:px-10">
        <div className="text-center mb-24">
          <span className="text-amber-600 tracking-[0.3em] text-xs font-bold uppercase block mb-3">
            Our Expertise
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-5">
            Materials & Technology We Use
          </h2>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg">
            We believe that quality waterproofing starts with the right materials and modern technology.
            That’s why we use industry-grade products and proven techniques to deliver durable, reliable,
            and long-lasting waterproofing solutions.
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {materials.map((item, i) => (
            <div
              key={i}
              className="bg-gray-50 rounded-3xl shadow-xl overflow-hidden group hover:shadow-2xl transition"
            >
              <div className="overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-60 object-cover transform transition duration-700 group-hover:scale-110"
                />
              </div>

              <div className="p-8">
                <h3 className="text-xl font-serif text-neutral-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TRUSTED BRANDS - NOW SEPARATE & BELOW */}
      <section className="relative py-32 bg-neutral-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_#f59e0b22,_transparent_60%)]"></div>

        <div className="relative max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            
            <div>
              <span className="text-amber-400 tracking-[0.3em] text-xs font-bold uppercase block mb-4">
                Quality Partners
              </span>

              <h3 className="text-4xl md:text-5xl font-serif mb-6 leading-tight">
                Trusted Brands <br /> We Work With
              </h3>

              <p className="text-gray-300 text-lg leading-relaxed">
                We collaborate with India’s most trusted waterproofing brands like 
                <span className="text-white font-semibold"> Dr. Fixit</span>, 
                <span className="text-white font-semibold"> Asian Paints SmartCare</span>, 
                <span className="text-white font-semibold"> Fosroc</span>, 
                <span className="text-white font-semibold"> Sika</span> and more to 
                deliver long-lasting and industry-grade solutions.
              </p>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/30 to-blue-500/30 rounded-3xl blur-2xl"></div>
              
              <div className="relative bg-neutral-800/80 backdrop-blur-xl rounded-3xl p-10 shadow-2xl border border-white/10">
                <h4 className="text-xl font-semibold mb-4 text-amber-400">
                  Why These Brands?
                </h4>
                <ul className="space-y-3 text-gray-300">
                  <li>✔ ISO Certified Materials</li>
                  <li>✔ 10+ Years Product Warranty</li>
                  <li>✔ Tested for Indian Climate</li>
                  <li>✔ Approved by Engineers</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MaterialsTechnology;
